import React, { Fragment, useMemo, VFC } from 'react';
import { JourneyMenu, JourneyMenuPropsInterface } from 'src/common/JourneyMenu';
import { EditorContentActivePanelTypes } from './card-options';
import { useReactConstructor } from 'src/utils/react/constructor.hook';
import { Nullable } from 'src/types/nullable.type';

export type EditorContentCardOptionsMenuItem = {
  type: EditorContentActivePanelTypes;
  render: () => Nullable<JSX.Element>;
  onClick: React.MouseEventHandler;
};

export interface EditorContentCardOptionsMenuProps
  extends Pick<JourneyMenuPropsInterface, 'openRef' | 'closeRef' | 'renderOrigin' | 'offset' | 'placement'> {
  onOpen: () => void;
  onClose: () => void;
  items: EditorContentCardOptionsMenuItem[];
}

const menuItemClasses = 'text-bedrock-p text-bedrock-black flex items-center space-x-sm';

export const EditorContentCardOptionsMenu: VFC<EditorContentCardOptionsMenuProps> = ({
  openRef,
  closeRef,
  onOpen,
  offset,
  placement,
  onClose,
  renderOrigin,
  items,
}) => {
  useReactConstructor(() => {
    return () => {
      onClose();
    };
  });

  const menuOptions = useMemo(() => {
    return items.map((item: EditorContentCardOptionsMenuItem) => {
      return (
        <JourneyMenu.Item className={menuItemClasses} onClick={item.onClick}>
          {item.render()}
        </JourneyMenu.Item>
      );
    });
  }, [items]);

  return (
    <JourneyMenu
      placement={placement}
      offset={offset}
      popperClassName='!fixed'
      openRef={openRef}
      closeRef={closeRef}
      onOpen={onOpen}
      onClose={onClose}
      renderOrigin={renderOrigin}
    >
      {menuOptions.map((option, index) => (
        <Fragment key={`menu-item-${index}`}>{option}</Fragment>
      ))}
    </JourneyMenu>
  );
};
